module.exports = __webpack_public_path__ + "static/media/ceremony81.db64572b.png";